import { combineReducers } from 'redux';
import MAIN_REDUCER from "./mainReducer"


export default combineReducers({
  global_access:MAIN_REDUCER
});
